export const getLang = () => {
  return new URLSearchParams(window.location.search).get("lang") || "tr";
};

export const withLang = (to) => {
  const lang = getLang();

  if (!to || to === "#") return to;

  if (to.includes("lang=")) return to;

  if (to.includes("?")) {
    return `${to}&lang=${lang}`;
  }

  return `${to}?lang=${lang}`;
};